/**
 * Navigation
 */

const navigation = () => {
  const config = {
    dom: {
      dataset: {
        linkTitle: "data-link-title",
      },
      element: {
        headerTopMenu: "js-header-menu-top-menu",
        headerInlineMenu: "js-header-inline-menu",
      },
      cls: {
        isLoading: "is-loading",
      },
    },
    style: {
      display: {
        none: "none",
      },
    },
  };

  let elementsToHide = [];

  if (window.Corra.header && window.Corra.header.elementsToHide) {
    elementsToHide = elementsToHide.concat(window.Corra.header.elementsToHide);
  }

  if (window.Corra.footer && window.Corra.footer.elementsToHide) {
    elementsToHide = elementsToHide.concat(window.Corra.footer.elementsToHide);
  }

  const $headerInlineMenu = document.querySelector(
    `.${config.dom.element.headerInlineMenu}`
  );

  const $headerTopMenu = document.querySelector(
    `.${config.dom.element.headerTopMenu}`
  );

  /**
   * Handleize String
   * @param {String} string string to handleize
   * @returns string
   */
  const handleizeString = (string) => {
    return string.toLowerCase().replace(" ", "-").trim();
  };

  /**
   * Hide Menu Items
   */
  const hideMenuItems = async () => {
    try {
      const $elements = document.querySelectorAll(
        `[${config.dom.dataset.linkTitle}]`
      );

      $elements.forEach(($element) => {
        if (
          elementsToHide.some(
            (element) => handleizeString(element) === $element.dataset.linkTitle
          )
        ) {
          $element.style.display = config.style.display.none;
        }
      });
    } catch (error) {
      console.error(`hideMenuItems(): ${error}`);
    }
  };

  /**
   * Remove Class
   * @param {DOM Element} $element element to remove class from
   * @param {String} className class name to remove from $element
   */
  const removeClass = ($element, className) => {
    try {
      $element.classList.contains(className) &&
        $element.classList.remove(className);
    } catch (error) {
      console.error(`removeClass(): ${error}`);
    }
  };

  /**
   * Remove Loading State
   */
  const removeLoadingState = async () => {
    try {
      removeClass($headerInlineMenu, config.dom.cls.isLoading);
      removeClass($headerTopMenu, config.dom.cls.isLoading);
    } catch (error) {
      console.error(`removeLoadingState(): ${error}`);
    }
  };

  /**
   * Init
   */
  const init = async () => {
    try {
      await hideMenuItems();
    } catch (error) {
      console.error(`navigation.js > init(): ${error}`);
    } finally {
      await removeLoadingState();
    }
  };

  init();
};

navigation();
